import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=fb844ba2&"
import script from "./DownloadLink.vue?vue&type=script&lang=ts&"
export * from "./DownloadLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports